export default [
  {
    id: 'f1-id',
    value: '1',
    label: '1',
    tracking: 'ga-search-form-toggle-1-bedroom'
  },
  {
    id: 'f2-id',
    value: '2',
    label: '2',
    tracking: 'ga-search-form-toggle-2-bedroom'
  },
  {
    id: 'f3-id',
    value: '3',
    label: '3',
    tracking: 'ga-search-form-toggle-3-bedroom'
  },
  {
    id: 'f4-id',
    value: '4',
    label: '4',
    tracking: 'ga-search-form-toggle-4-bedroom'
  },
  {
    id: 'f4more-id',
    value: '4more',
    label: '+4',
    tracking: 'ga-search-form-toggle-4more-bedroom'
  }
];
